export const Work = [
    {
        id:1,
        name:"Software Development Engineer",
        description:"I developed and maintained NodeRED APIs, ensuring smooth data flow and resolving backend issues for system stability. I also used Postman for API testing and documentation.",
        tags:["node-red","postman"],
        company:"https://drive.google.com/uc?export=view&id=1MULfBY-kwvZRpWZk3pVDCmgFs4GJwdS7",
        duration:"5 months",
        link: "http://irasus.com/"
       
    },
    {
        id:2,
        name:"UI/UX Designer",
        description:"Created user-centric designs and collaborated with developers for seamless implementation. Conducted user research and usability testing for optimized designs.",
        tags:["figma","adobe xd"],
        company:"https://drive.google.com/uc?export=view&id=1MULfBY-kwvZRpWZk3pVDCmgFs4GJwdS7",
        duration:"Present",
        link: "http://irasus.com/"
       
        
    },
] 